import React from 'react';
import { shouldUpdate } from 'recompose';
import StatCounter from '../../common/StatCounter/StatCounter';
import globals from '../../../globals/communityGlobals';
import timePropTypes from '../../../propTypes/entities/time';

const locale = globals.getArea('dailyPlanning');

const Stats = ({
  availableHours,
  allocatedHoursForAssignments,
  allocatedHours,
  allocatedHoursForNonPatientAssignments,
  unallocatedHours,
}) => (
  <div className="right-items">
    <StatCounter value={availableHours} text={locale.getMsg('availableHours')} />
    <StatCounter value={allocatedHours} text={locale.getMsg('allocatedHours')} />
    <StatCounter value={allocatedHoursForAssignments} text={locale.getMsg('allocatedHoursForAssignments')} />
    <StatCounter
      value={allocatedHoursForNonPatientAssignments}
      text={locale.getMsg('allocatedHoursForNonPatientAssignments')}
    />
    <StatCounter value={unallocatedHours} text={locale.getMsg('totalHoursToAllocate')} />
  </div>
);

Stats.propTypes = {
  availableHours: timePropTypes.isRequired,
  allocatedHours: timePropTypes.isRequired,
  allocatedHoursForAssignments: timePropTypes.isRequired,
  allocatedHoursForNonPatientAssignments: timePropTypes.isRequired,
  unallocatedHours: timePropTypes.isRequired,
};

const checkPropsChange = (props, nextProps) =>
  props.availableHours !== nextProps.availableHours ||
  props.allocatedHours !== nextProps.allocatedHours ||
  props.allocatedHoursForAssignments !== nextProps.allocatedHoursForAssignments ||
  props.allocatedHoursForNonPatientAssignments !== nextProps.allocatedHoursForNonPatientAssignments ||
  props.unallocatedHours !== nextProps.unallocatedHours;

export default shouldUpdate(checkPropsChange)(Stats);
